import { createContext, useContext, useEffect, useState } from "react";
import { accountsConfigured, getSupabaseClient } from "./supabaseClient";

export const AuthContext = createContext({ configured: false, loading: false, session: null });
export const useAuth = () => useContext(AuthContext);

const AuthProvider = ({ children, configured = accountsConfigured, loadClient = getSupabaseClient }) => {
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({ client: null, session: null, loading: configured, error: "" });
  useEffect(() => {
    if (!configured) return;
    let active = true;
    let subscription;
    let eventVersion = 0;
    setState(previous => ({ ...previous, loading: true, error: "" }));
    loadClient().then(async client => {
      if (!active) return;
      if (!client) throw new Error("Account connection is unavailable");
      setState(previous => ({ ...previous, client }));
      subscription = client.auth.onAuthStateChange((_event, session) => {
        if (!active) return;
        eventVersion++;
        setState({ client, session, loading: false, error: "" });
      }).data.subscription;
      const version = eventVersion;
      const { data, error } = await client.auth.getSession();
      if (!active || eventVersion !== version) return;
      if (error) throw error;
      setState({ client, session: data.session, loading: false, error: "" });
    }).catch(() => {
      if (active) setState(previous => ({ ...previous, loading: false,
        error: "Could not restore your account session. Please try again." }));
    });
    return () => { active = false; subscription?.unsubscribe(); };
  }, [configured, loadClient, attempt]);

  return <AuthContext.Provider value={{ ...state, configured,
    retry: () => setAttempt(value => value + 1) }}>{children}</AuthContext.Provider>;
};

export default AuthProvider;
